import { FRESH_FROZEN } from '@/constants';
import { TRANSFER_CLINIC_RANCH_HAULIN } from '@/constants';
import { LOAD_DONOR_PARTNERS_OPTION_VALUES } from '@/enums';

export const FRESH_FROZEN_OPTIONS = Object.entries(FRESH_FROZEN).map(
  ([label, value]) => ({
    label,
    value,
  }),
);

export const TRANSFER_CLINIC_RANCH_HAULIN_OPTIONS = [
  { label: 'Clinic', value: TRANSFER_CLINIC_RANCH_HAULIN.CLINIC },
  { label: 'Ranch', value: TRANSFER_CLINIC_RANCH_HAULIN.RANCH },
  { label: 'Haul-In', value: TRANSFER_CLINIC_RANCH_HAULIN.HAUL_IN },
];

export const LOAD_DONOR_PARTNERS_OPTIONS = [
  { label: 'Yes', value: LOAD_DONOR_PARTNERS_OPTION_VALUES.YES },
  { label: 'No', value: LOAD_DONOR_PARTNERS_OPTION_VALUES.NO },
];

export const STEPS = [
  {
    label: 'General',
    description: 'Basic embryo information',
  },
  {
    label: 'Transfers',
    description: 'Transfer details',
  },
  {
    label: 'Freezing',
    description: 'Freezing information',
  },
];

export const STEPS_V2 = [
  {
    label: 'General',
    description: 'Basic embryo information',
  },
  {
    label: 'Fresh Implant',
    description: 'Implant details',
  },
  {
    label: 'Frozen',
    description: 'Frozen information',
  },
];

export const DEFAULT_VALUES = {
  donorId: undefined,
  sireId: undefined,
  freezeOwnerId: undefined,
  transferOwnerId: undefined,
  breedId: undefined,
  method: undefined,
  recoveryFirmCode: undefined,
  recoveryFirmName: undefined,
  freshFrozen: undefined,
  freezeCane: undefined,
  creation: undefined,
  freezeTechName: undefined,
  freezeMethodId: undefined,
  implantDate: undefined,
  transferQuantity: 0,
  thawByName: '',
  implantTierOf: undefined,
  transferSiteId: undefined,
  transferClinicRanchHaulIn: undefined,
  transferTechName: '',
  implantType: undefined,
  recipientOwnerId: undefined,
  deyardId: undefined,
  freezeQuantity: 0,
  freezeStorageLocationId: undefined,
  receivedOn: undefined,
  freezeTt: undefined,
  freezer: undefined,
  freezeTime: undefined,
  stage: undefined,
  grade: undefined,
};
